/// <amd-module name="Artifacts/Root/types/MetricType" />
export enum MetricType {
  DownloadCount,
  UniqueUsers,
}
